/**
 * @generated SignedSource<<e5d54446f3d04687cbbc25d40ac165db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCell_rateByRoom$data = {
  readonly __id: string;
  readonly room: {
    readonly id: string;
  };
  readonly roomRate: {
    readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCellValue_roomRate">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_rateByRoom">;
  readonly " $fragmentType": "RoomRatesTableRateCell_rateByRoom";
};
export type RoomRatesTableRateCell_rateByRoom$key = {
  readonly " $data"?: RoomRatesTableRateCell_rateByRoom$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_rateByRoom">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCell_rateByRoom",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoomRate",
      "kind": "LinkedField",
      "name": "roomRate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomRatesTableRateCellValue_roomRate"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditor_rateByRoom"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RateByRoom",
  "abstractKey": null
};

(node as any).hash = "6aa0d09f8cb06683b502bc002f4f8d01";

export default node;
